/**
 * Global debug configuration for the SDK
 * Controls whether throughput and rate change monitoring/logs are enabled
 */
class DebugConfig {
  private _enableStreamMonitoring: boolean = false;

  /**
   * Set whether to enable throughput and rate change monitoring/logs
   * @param enable - If true, monitoring and logs will be enabled
   */
  setEnableStreamMonitoring(enable: boolean): void {
    this._enableStreamMonitoring = enable;
  }

  /**
   * Check if monitoring is enabled
   * @returns true if monitoring should be enabled
   */
  isStreamMonitoringEnabled(): boolean {
    return this._enableStreamMonitoring;
  }
}

// Export singleton instance
export const debugConfig = new DebugConfig();
